// extracted by mini-css-extract-plugin
export default {"content":"style_content__O+jD-","leftSide":"style_leftSide__LqbLC","rightSide":"style_rightSide__PblDy","type":"style_type__jv+RR"};